var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.245 8.88892L12 4.5L7.755 8.88892C6.585 10.1007 6 11.7165 6 13.2701C6 14.8237 6.585 16.4627 7.755 17.6745C8.925 18.8863 10.4625 19.5 12 19.5C13.5375 19.5 15.075 18.8863 16.245 17.6745C17.415 16.4627 18 14.8237 18 13.2701C18 11.7165 17.415 10.1007 16.245 8.88892ZM7.5 13.5497C7.5075 11.9961 7.965 11.0096 8.82 10.1318L12 6.76825L15.18 10.1706C16.035 11.0407 16.4925 11.9961 16.5 13.5497H7.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropSolid);
export default __webpack_public_path__ + "static/media/drop-solid.fd0a44e21d99725acb40d35dd875e4e8.svg";
export { ForwardRef as ReactComponent };